import React from 'react';
import Bit from '../../assets/svgs/Bit.svg';
import Culture2 from '../../assets/svgs/cs5.svg';
import Bits1 from '../../assets/images/BIT3.png';
import Bits3 from '../../assets/images/BIT1.png';
import Bits4 from '../../assets/images/BIT2.png';

import Logo1 from '../../assets/images/course1.png';
import Logo3 from '../../assets/images/course3.png';
import Logo2 from '../../assets/images/course2.png';

function BitSchool() {
  return (
    <section className="relative mb-28 sm:mb-52 mt-20">
      <div className="content">
        <img src={Logo1} alt="" className="hidden lg:block w-32 h-auto right-24 absolute" />
        <div className="md-2:flex relative">
          <div className="w-full mb-10 md-2:w-[calc(100%-500px)] md-2:mb-0 flex">
            <div className="w-full text-center md-2:pr-14 md-2:text-left">
              <h1 className="section-header">Schools</h1>
              <p className="font-semibold text-primary">Bankers In Training School</p>
              <p className="big-p mb-5 md:mb-0 mt-5">
                Bankers in training schools offers a comprehensive programme designed
                to equip students with a deep understanding of banking operations.
                These programme not only offer valuable insights into industry
                practices but also facilitate mentorship and job opportunities,
                bankers in training school contribute to the stability,
                growth and integrity of the global financial system
              </p>
            </div>
          </div>
          <div className="w-full sm:w-[500px] mx-auto">
            <div className="w-full h-[400px] sm:h-[500px] flex space-x-4">
              <div className="w-2/3 bg-gray-300 relative overflow-hidden">
                <img src={Bits1} alt="Caring and Sharing" className="interactive-picture" />
              </div>
              <div className="w-1/3 h-full flex flex-wrap space-y-4">
                <div className="w-full h-[calc(50%-16px)] bg-primary overflow-hidden">
                  <img src={Bit} alt="" className="" />
                </div>
                <div className="w-full h-1/2 bg-gray-300 relative overflow-hidden">
                  <img src={Bits3} alt="Caring and Sharing" className="interactive-picture" />
                </div>
              </div>
            </div>
            <div className="w-full h-[250px] lg:h-[280px] sm:h-[220px] flex space-x-4 mt-4">
              <div className="w-2/3 bg-gray-300 relative overflow-hidden">
                <img src={Bits4} alt="Caring and Sharing" className="interactive-picture" />
              </div>
              <div className="w-2/3 h-full flex flex-wrap space-y-4">
                <div className="w-full h-full overflow-hidden">
                  <img src={Culture2} alt="" className="" />
                </div>
              </div>
            </div>
          </div>
          <div className="">
            <img src={Logo3} alt="" className="hidden lg:block w-32 h-32 absolute -left-48 mt-[520px] object-contain" />
          </div>
          <div className="">
            <img src={Logo2} alt="" className="hidden lg:block w-32 h-32 absolute -right-36 mt-[660px] object-contain" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default BitSchool;
